var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 334,
    height: 334,
    viewBox: "0 0 334 334",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000553643H47.997V334H0V0.000553643Z",
    fill: "#BD6748"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.997 286.002H333.999V333.999L47.997 334L47.997 286.002Z",
    fill: "#BD6748"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M191.493 238.005H239.49V286.002H191.493V238.005Z",
    fill: "#BD6748"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M286.001 47.9977H333.998V94.0154H286.001V47.9977Z",
    fill: "#BD6748"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4976 238.005H143.495V286.002H95.4976V238.005Z",
    fill: "#BD6748"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.997 190.008H143.496L143.495 238.005L47.997 238.005V190.008Z",
    fill: "#BD6748"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M191.493 190.008H333.999V238.005L191.493 238.005V190.008Z",
    fill: "#BD6748"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9848 94.014L333.998 94.0154L334.001 142.011H96.9848V94.014Z",
    fill: "#BD6748"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9848 0H334.001L333.998 47.9977L96.9848 47.997V0Z",
    fill: "#BD6748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.ec8712be73d6e29e1d0a0197c65d760c.svg";
export { ForwardRef as ReactComponent };